import api from '@/api/permissions'

const state = {
    item: null,
    items: [],
    pagination: null,
    permissions_list: [],
}

const mutations = {
    set_item(state, payload) {
        state.item = payload
    },
    set_permission_list(state, payload) {
        state.permissions_list = payload
    },
    set(state, payload) {
        state.items = payload
    },
    delete(state, id) {
        let index = state.items.findIndex(x => x.id == id)
        state.items.splice(index, 1)
        console.log('deleted item at index ' + index)
    },
    set_pagination(state, pag) {
        state.pagination = pag
    },
}

const actions = {
    create(context, payload) {
        return api.create(payload).then(() => {
            context.dispatch('all')
        })
    },
    fetch(context, payload) {
        return api
            .fetch(payload.query, payload.page)
            .then(
                ({
                    data: {
                        success: { data: pag },
                    },
                }) => {
                    let items = pag.data

                    context.commit('set', items)
                    //let pag = result.data.success.data
                    context.commit('set_pagination', {
                        page: pag.current_page,
                        pageSize: pag.per_page,
                        total: pag.total,
                    })
                }
            )
            .catch(err => {
                throw err
            })
    },
    all(context) {
        return api
            .all()
            .then(
                ({
                    data: {
                        success: { data: item },
                    },
                }) => {
                    context.commit('set_permission_list', item)
                }
            )
            .catch(err => {
                throw err
            })
    },
    fetchById(context, id) {
        console.log('id', id)
        return api
            .fetchById(id)
            .then(
                ({
                    data: {
                        success: { data: item },
                    },
                }) => {
                    console.log('assumed permissions', item)
                    context.commit('set_item', item)
                }
            )
            .catch(err => {
                throw err
            })
    },
    update(context, payload) {
        return api
            .update(payload.id, payload)
            .then(() => {
                context.dispatch('all')
            })
            .catch(err => {
                throw err
            })
    },
    delete(context, id) {
        console.log('deleting')
        return api
            .delete(id)
            .then(() => {
                context.dispatch('all')
                context.commit('delete', id)
            })
            .catch(err => {
                throw err
            })
    },
}

const getters = {
    permissions(state) {
        return state.items
    },
}

export default {
    namespaced: true,
    state,
    mutations,
    actions,
    getters,
}
